import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Automatic JWT Bearer Token Interceptor
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Global Error / Unauthenticated Token Expiry Interceptor
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      if (
        error.response.data &&
        error.response.data.error &&
        error.response.data.error.includes("Disabled")
      ) {
        // Account disabled alert
      } else {
        // Optional token auto-logout if token is expired
      }
    }
    return Promise.reject(error);
  },
);

export default axiosClient;
